"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 * E = Eligibility
 * G = General
 * V = Validation
 */
var _default = exports["default"] = {
  "E001": {
    "verbiage": {
      "en": "Claim failed because the dependent is disabled. If this is a mistake, please contact an administrator.",
      "fr": "La réclamation a échoué car la personne à charge est handicapée. S'il s'agit d'une erreur, veuillez contacter un administrateur."
    },
    "sysMsg": "Claim failed for the provided dependent: params[0] because the dependent is disabled.",
    "code": "DEPENDENT_DISABLED"
  },
  "E002": {
    "verbiage": {
      "en": "You have fallen into Late Applicant Status. This means you are not able to enroll with Simply Benefits at this time. Please contact your plan administrator to remedy the issue.",
      "fr": "Vous êtes tombé dans le statut de demandeur tardif. Cela signifie que vous ne pouvez pas vous inscrire à Simply Benefits pour le moment. Veuillez contacter l'administrateur de votre régime pour remédier au problème."
    },
    "sysMsg": "User params[0] is trying to enrol but are set as a Late Applicant.",
    "code": "INVALID_USER"
  },
  "E003": {
    "verbiage": {
      "en": "You have been terminated from the group. If you believe this is in error, please contact your plan administrator.",
      "fr": "Vous avez été exclu du groupe. Si vous pensez qu’il s’agit d’une erreur, veuillez contacter l’administrateur de votre régime."
    },
    "sysMsg": "User params[0] is trying to enrol but has been terminated.",
    "code": "INVALID_USER"
  },
  "E004": {
    "verbiage": {
      "en": "Hey, it looks like you have already enrolled! Please navigate to the login screen to access your account.",
      "fr": "Hé, il semble que vous soyez déjà inscrit ! Veuillez accéder à l'écran de connexion pour accéder à votre compte."
    },
    "sysMsg": "User params[0] is trying to enrol but they have already enrolled.",
    "code": "INVALID_USER"
  },
  "E005": {
    "verbiage": {
      "en": "The provided member is not eligible for Maple coverage.",
      "fr": "Le membre fourni n’est pas admissible à la couverture Maple."
    },
    "sysMsg": "The provided cert from Maple is not eligible for Maple coverage.",
    "code": "NO_COVERAGE"
  },
  "E006": {
    "verbiage": {
      "en": "Your admin account is disabled.",
      "fr": "Votre compte administrateur est désactivé."
    },
    "sysMsg": "The admin: params[0] is trying to login with a disabled account.",
    "code": "INVALID_USER"
  },
  "E007": {
    "verbiage": {
      "en": "Your admin account has been terminated.",
      "fr": "Votre compte administrateur a été résilié."
    },
    "sysMsg": "The admin: params[0] is trying to login with a terminated account.",
    "code": "INVALID_USER"
  },
  "E008": {
    "verbiage": {
      "en": "Your account has not been configured, please contact your advisor.",
      "fr": "Votre compte n'est pas configuré, veuillez contacter votre conseiller."
    },
    "sysMsg": "params[0] is trying to login but there is no account record for account: params[1]",
    "code": "UNAUTHORIZED"
  },
  "E009": {
    "verbiage": {
      "en": "Your advisor is still configuring your group plan. You will be notified when it is ready for use.",
      "fr": "Votre conseiller est toujours en train de configurer votre régime collectif. Vous serez averti lorsqu'il sera prêt à être utilisé."
    },
    "sysMsg": "Advisor is not finished with account setup for: params[0].",
    "code": "UNAUTHORIZED"
  },
  "E010": {
    "verbiage": {
      "en": "Your advisor account is disabled.",
      "fr": "Votre compte conseiller est désactivé."
    },
    "sysMsg": "The advisor: params[0] is trying to login with a disabled account.",
    "code": "INVALID_USER"
  },
  "E011": {
    "verbiage": {
      "en": "Your advisor account is terminated.",
      "fr": "Votre compte conseiller est résilié."
    },
    "sysMsg": "The advisor: params[0] is trying to login with a terminated account.",
    "code": "INVALID_USER"
  },
  "E012": {
    "verbiage": {
      "en": "Cannot add an employee with coverage this far in the past. Please contact administration@simplybenefits.ca for more information.",
      "fr": "Impossible d'ajouter un employé bénéficiant d'une couverture aussi lointaine dans le passé. Veuillez contacter administration@simplybenefits.ca pour plus d’informations."
    },
    "sysMsg": "The advisor is trying to add a user with a hire date backdated more than three months.",
    "code": "INVALID_REQUEST"
  },
  "E013": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you were not eligible for Health Spending at the time of service.",
      "fr": "Désolé, la demande n'a pas pu être complétée car vous n'étiez pas admissible aux dépenses de santé au moment du service."
    },
    "sysMsg": "User is trying to make a Health Spending Top Off but they were not covered for Health Spending at time of service.`",
    "code": "NO_COVERAGE"
  },
  "E014": {
    "verbiage": {
      "en": "The selected agent does not have 'Dental' assigned as an agent benefit.",
      "fr": "L'agent sélectionné n'a pas d'avantage « Dentaire » attribué comme avantage d'agent."
    },
    "sysMsg": "Failed to assign agent params[0] to the dental claim params[1] because they do not have dental benefits assigned to them.",
    "code": ""
  },
  "E015": {
    "verbiage": {
      "en": "Claim cannot be processed because the provided service date does not fall within the designated rollover period. Please correct the service date or contact Simply Benefits.",
      "fr": "La réclamation ne peut pas être traitée car la date de service fournie ne tombe pas dans la période de roulement désignée. Veuillez corriger la date du service ou contacter Simply Benefits."
    },
    "sysMsg": "The provided params[0] service date falls outside the members rollover periods.",
    "code": "NO_COVERAGE"
  },
  "E016": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because your plan does not have Lifestyle Spending coverage for dependents.",
      "fr": "Désolé, la demande n'a pas pu être complétée car votre régime ne prévoit pas de couverture des dépenses liées au style de vie pour les personnes à charge."
    },
    "sysMsg": "A Acera (Capri) User is trying to make an LSA claim for a dependent but they do not have coverage.",
    "code": "NO_COVERAGE"
  },
  "E017": {
    "verbiage": {
      "en": "The provided claim receipt is invalid. Ensure the provided images are straight, clear, and well-lit.",
      "fr": "Le reçu de réclamation fourni n’est pas valide. Assurez-vous que les images fournies sont droites, claires et bien éclairées."
    },
    "sysMsg": "Failed to perform claim because we did not get any data from the receipt scanning",
    "code": "INSUFFICIENT_DATA"
  },
  "E018": {
    "verbiage": {
      "en": "Failed to compute user eligibility.",
      "fr": "Échec du calcul de l'éligibilité des utilisateurs."
    },
    "sysMsg": "The member with id: params[0] could not be found or their account record does not exist",
    "code": "NOT_FOUND"
  },
  "E019": {
    "verbiage": {
      "en": "Member could not be found.",
      "fr": "Le membre est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "E020": {
    "verbiage": {
      "en": "Dependent could not be found.",
      "fr": "La personne à charge est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "E021": {
    "verbiage": {
      "en": "Admin could not be found.",
      "fr": "L'administrateur est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "E022": {
    "verbiage": {
      "en": "Advisor could not be found.",
      "fr": "Le conseiller est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "E023": {
    "verbiage": {
      "en": "You cannot change your params[0] coverage until your renewal date on params[1]",
      "fr": "Vous ne pouvez pas modifier votre couverture params[0] avant votre date de renouvellement sur params[1]"
    },
    "sysMsg": "Member is trying to change their params[0] coverage but they have not reached their renewal date (params[1]) yet.",
    "code": "INVALID_REQUEST"
  },
  "E024": {
    "verbiage": {
      "en": "Sorry, you do not have an active spending account on your plan.",
      "fr": "Désolé, vous n'avez pas de compte de dépenses actif sur votre forfait."
    },
    "sysMsg": "The member: params[0], is trying to use a spending account but they do not have a spending account.",
    "code": "NOT_FOUND"
  },
  "E025": {
    "verbiage": {
      "en": "Sorry, your spending account is disabled until you have set your Pooled Spending Account maximums. Please navigate to the member portal to set your maximums.",
      "fr": "Désolé, votre compte de dépenses est désactivé jusqu'à ce que vous ayez défini les plafonds de votre compte de dépenses groupées. Veuillez accéder au portail des membres pour définir vos maximums."
    },
    "sysMsg": "The member: params[0], is trying to use their spending account but have not yet set their Pooled Spending Account maximums.",
    "code": "UNAUTHORIZED"
  },
  "E026": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you were not yet eligible at the time of service.",
      "fr": "Désolé, la demande n'a pas pu être complétée car vous n'étiez pas encore éligible au moment du service."
    },
    "sysMsg": "params[0] is trying to make a params[1] claim but they were not eligible at time of service.",
    "code": "ELIGIBILITY_FAILED"
  },
  "E027": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you have waived coverage. If this is a mistake please contact your Administrator.",
      "fr": "Désolé, la réclamation n'a pas pu être complétée car vous avez renoncé à la couverture. S'il s'agit d'une erreur, veuillez contacter votre administrateur."
    },
    "sysMsg": "params[0] is trying to make a claim but the service date: params[1] is from after their benefit (params[2]) waive date.",
    "code": ""
  },
  "E028": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you were not covered for Health Spending at the time of service.",
      "fr": "Désolé, la demande n'a pas pu être complétée car vous n'étiez pas couvert pour les dépenses de santé au moment du service."
    },
    "sysMsg": "User is trying to make a Health Spending Top Off but they were not covered for Health Spending at time of service.",
    "code": ""
  },
  "E029": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you were not covered for Lifestyle Spending at the time of service.",
      "fr": "Désolé, la demande n'a pas pu être complétée car vous n'étiez pas couvert pour vos dépenses liées au style de vie au moment du service."
    },
    "sysMsg": "User is trying to make a Lifestyle Spending claim but they were not covered for Lifestyle Spending at time of service.",
    "code": "NO_COVERAGE"
  },
  "E030": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because the service date is from before your Simply Benefits coverage started.",
      "fr": "Désolé, la réclamation n’a pas pu être complétée car la date de service est antérieure au début de votre couverture Simply Benefits."
    },
    "sysMsg": "params[0] is trying to make a claim but the service date: params[1] is from before their effective date: params[2].",
    "code": "NO_COVERAGE"
  },
  "E031": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because the service date is from more than 1 year ago.",
      "fr": "Désolé, la réclamation n'a pas pu être complétée car la date de service date d'il y a plus d'un an."
    },
    "sysMsg": "params[0] is trying to make a claim but the service date: params[1] is more than a year ago.",
    "code": "NO_COVERAGE"
  },
  "E032": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because the primary policy holder has reached the termination age for the benefit.",
      "fr": "Désolé, la réclamation n'a pas pu être complétée car le preneur d'assurance principal a atteint l'âge de résiliation de la garantie."
    },
    "sysMsg": "params[0] is trying to make a params[1] claim but the member has reached their termination age.",
    "code": ""
  },
  "E033": {
    "verbiage": {
      "en": "The provided benefit and category is not supported.",
      "fr": "L'avantage et la catégorie fournis ne sont pas pris en charge."
    },
    "sysMsg": "The provided benefit: params[0] and category: params[1] could not be found in system.",
    "code": "INVALID_REQUEST"
  },
  "E034": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you have reached your maximum.",
      "fr": "Désolé, la réclamation n'a pas pu être finalisée car vous avez atteint votre maximum."
    },
    "sysMsg": "User is trying to make a params[0] claim but they have reached their maximum.",
    "code": "NO_COVERAGE"
  },
  "E035": {
    "verbiage": {
      "en": "The provided service date does not fall within the designated rollover period.",
      "fr": "La date de service fournie ne tombe pas dans la période de roulement désignée."
    },
    "sysMsg": "",
    "code": ""
  },
  "E036": {
    "verbiage": {
      "en": "The certificate has not been placed in a Survivor Benefit status and is missing a deceased primary cert meta record.",
      "fr": "Le certificat n'a pas été placé dans un statut de prestation de survivant et il manque un méta-enregistrement de certificat principal décédé."
    },
    "sysMsg": "The certificate has not been placed in a Survivor Benefit status and is missing a deceased primary cert meta record.",
    "code": "NOT_FOUND"
  },
  "E037": {
    "verbiage": {
      "en": "The member does not have an active leave status.",
      "fr": "Le membre n'a pas de statut de congé actif."
    },
    "sysMsg": "Master Site user is trying to change the expected return date but the member: params[0] has no active leave records.",
    "code": "NOT_FOUND"
  },
  "E038": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because the service date is from after your termination date.",
      "fr": "Désolé, la réclamation n'a pas pu être complétée car la date de service est postérieure à votre date de résiliation."
    },
    "sysMsg": "params[0] is trying to make a claim but the service date: params[1] is from after their termination date: params[2].",
    "code": "NO_COVERAGE"
  },
  "E039": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you are no longer in your termination grace period.",
      "fr": "Désolé, la réclamation n'a pas pu être traitée car vous n'êtes plus dans votre délai de grâce de résiliation."
    },
    "sysMsg": "params[0] is trying to make a claim but the termination date: params[1] is more than 90 days ago.",
    "code": "NO_COVERAGE"
  },
  "E040": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you do not have the selected benefit active under your plan.",
      "fr": "Désolé, la demande n'a pas pu être complétée car la garantie sélectionnée n'est pas active dans votre régime."
    },
    "sysMsg": "params[0] is trying to make a claim but the benefit (params[1]) is not active.",
    "code": "NO_COVERAGE"
  },
  "E041": {
    "verbiage": {
      "en": "Sorry, the claim could not be completed because you were not covered for the benefit at the time of service.",
      "fr": "Désolé, la demande n'a pas pu être complétée car vous n'étiez pas couvert pour la prestation au moment du service."
    },
    "sysMsg": "params[0] is trying to make a params[1] claim but the benefit was not active at time of service.",
    "code": ""
  },
  "E042": {
    "verbiage": {
      "en": 'Multiple params[0] returned for "stripeCustomerID".',
      "fr": 'Plusieurs params[0] renvoyés pour "stripeCustomerID".'
    },
    "sysMsg": 'Invalid Number of params[0] associated to "stripeCustomerID" for Stripe webhook event: params[1]',
    "code": 'INVALID_REQUEST'
  },
  "E043": {
    "verbiage": {
      "en": 'There are an invalid amount of invoices associated with a Stripe webhook event',
      "fr": 'Il y a un nombre non valide de factures associées à un événement webhook Stripe'
    },
    "sysMsg": 'Invalid Number of Invoices for Stripe webhook event: params[0]',
    "code": 'INVALID_REQUEST'
  },
  "E044": {
    "verbiage": {
      "en": 'The provided "stripeCustomerID" is not associated with either a division or user.',
      "fr": "Le \"stripeCustomerID\" fourni n'est associ\xE9 ni \xE0 une division ni \xE0 un utilisateur."
    },
    "sysMsg": 'A division or user could not be associated to the provided "stripeCustomerID" in Stripe webhook event: params[0]',
    "code": 'NOT_FOUND'
  },
  "E045": {
    "verbiage": {
      "en": 'The record associated with Failed CC Payment could not be found. See Stripe events for details.',
      "fr": "L'enregistrement associé à l'échec du paiement CC est introuvable. Voir Événements Stripe pour plus de détails."
    },
    "sysMsg": 'Failed Payment Id not found for Stripe webhook event: params[0]',
    "code": 'NOT_FOUND'
  },
  "E046": {
    "verbiage": {
      "en": "You have already purchased params[0], please contact Simply Benefits support if you need assistance.",
      "fr": "Vous avez déjà acheté params[0], veuillez contacter le support de Simply Benefits si vous avez besoin d'aide."
    },
    "sysMsg": "Member is trying to change their Optional params[0] coverage but they have already purchased it in the past.",
    "code": "INVALID_REQUEST"
  },
  "G001": {
    "verbiage": {
      "en": "No users found with provided criteria.",
      "fr": "Aucun utilisateur trouvé avec les critères fournis."
    },
    "sysMsg": "",
    "code": ""
  },
  "G002": {
    "verbiage": {
      "en": "A system error occurred.",
      "fr": "Une erreur système s'est produite."
    },
    "sysMsg": "params[0]",
    "code": "INTERNAL_ERROR"
  },
  "G003": {
    "verbiage": {
      "en": "Your session has expired. Please login again.",
      "fr": "Votre session a expiré. Veuillez vous reconnecter."
    },
    "sysMsg": "Session has expired: params[0]",
    "code": "INVALID_TOKEN"
  },
  "G004": {
    "verbiage": {
      "en": "Uh oh, it looks like you do not have the latest app version. Please ensure you are using the latest Simply Benefits app version from the App Store.",
      "fr": "Oh oh, il semble que vous n'ayez pas la dernière version de l'application. Veuillez vous assurer que vous utilisez la dernière version de l'application Simply Benefits disponible sur l'App Store."
    },
    "sysMsg": "User is trying to make a claim without providing a patient type. This means they do not have the latest app version and need to update.",
    "code": "CLAIM_FAILED"
  },
  "G005": {
    "verbiage": {
      "en": "Sorry, it looks like your Modular Flex account has not been configured correctly. Please contact Simply Benefits support.",
      "fr": "Désolé, il semble que votre compte Modular Flex n'ait pas été configuré correctement. Veuillez contacter l’assistance Simply Benefits."
    },
    "sysMsg": "The provided Modular Flex account is missing the required classes and is now breaking enrollment.",
    "code": "NOT_FOUND"
  },
  "G006": {
    "verbiage": {
      "en": "Domain not found. The provided domain does not belong to this organization.",
      "fr": "Domaine introuvable. Le domaine fourni n'appartient pas à cette organisation."
    },
    "sysMsg": "The provided email: params[0] does not belong to the organization: params[1]",
    "code": "FAILED_WHITELABEL_VALIDATION"
  },
  "G007": {
    "verbiage": {
      "en": "Something went wrong trying to save the banking details.",
      "fr": "Une erreur s'est produite lors de la tentative d'enregistrement des informations bancaires."
    },
    "sysMsg": "Failed to save the banking details because the details are undefined",
    "code": "INVALID_REQUEST"
  },
  "G008": {
    "verbiage": {
      "en": "The provided report type could not be found.",
      "fr": "Le type de rapport fourni est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "G009": {
    "verbiage": {
      "en": "Failed to create a ticket.",
      "fr": "Échec de la création d'un ticket."
    },
    "sysMsg": "Failed to create a ticket.",
    "code": "INTERNAL_ERROR"
  },
  "G010": {
    "verbiage": {
      "en": "Something failed checking the claim.",
      "fr": "Quelque chose a échoué lors de la vérification de la réclamation."
    },
    "sysMsg": "The provided params[0] claim type: params[1] does not exist in the table column mapping (amountAvailable).",
    "code": "NOT_FOUND"
  },
  "G011": {
    "verbiage": {
      "en": "There are no records for the provided claim.",
      "fr": "Il n’existe aucun enregistrement pour la réclamation fournie."
    },
    "sysMsg": "There are no records for the provided claim: claimID: params[0], multilineRefNum: params[1]",
    "code": "NOT_FOUND"
  },
  "G012": {
    "verbiage": {
      "en": "The type of change is unknown.",
      "fr": "Le type de changement est inconnu."
    },
    "sysMsg": "The provided type: params[0] is not a valid type for setting an effective date.",
    "code": "NOT_FOUND"
  },
  "G013": {
    "verbiage": {
      "en": "There was an issue finding the selected invoice. Please try again later.",
      "fr": "Un problème est survenu lors de la recherche de la facture sélectionnée. Veuillez réessayer plus tard."
    },
    "sysMsg": "The provided invoiceNum: params[0] could not be found in S3 under accountID/userID: params[1]",
    "code": "NOT_FOUND"
  },
  "G014": {
    "verbiage": {
      "en": "There was an issue finding the selected quote. Please try again later.",
      "fr": "Un problème est survenu lors de la recherche du devis sélectionné. Veuillez réessayer plus tard."
    },
    "sysMsg": "The provided quoteID: params[0] could not be found in S3.",
    "code": "NOT_FOUND"
  },
  "G015": {
    "verbiage": {
      "en": "There was an issue finding the selected revision. Please try again later.",
      "fr": "Un problème est survenu lors de la recherche de la révision sélectionnée. Veuillez réessayer plus tard."
    },
    "sysMsg": "Failed to find the provided revision.",
    "code": "NOT_FOUND"
  },
  "G016": {
    "verbiage": {
      "en": "Failed to generate invoice.",
      "fr": "Échec de la génération de la facture."
    },
    "sysMsg": "Failed to get the tax rate for the the benefit: params[0] and province: params[1]",
    "code": "NOT_FOUND"
  },
  "G017": {
    "verbiage": {
      "en": "There was an issue finding the selected ASO Report. Please try again later.",
      "fr": "Un problème est survenu lors de la recherche du rapport ASO sélectionné. Veuillez réessayer plus tard."
    },
    "sysMsg": "The provided asoReportID: params[0] could not be found in Dynamo",
    "code": "NOT_FOUND"
  },
  "G018": {
    "verbiage": {
      "en": "No invoices found with provided criteria.",
      "fr": "Aucune facture trouvée avec les critères fournis."
    },
    "sysMsg": "",
    "code": ""
  },
  "G019": {
    "verbiage": {
      "en": "There was an issue generating the Premium Remittance Report 2.0. Please try again.",
      "fr": "Un problème est survenu lors de la génération du rapport de remise des primes 2.0. Veuillez réessayer."
    },
    "sysMsg": "",
    "code": ""
  },
  "G020": {
    "verbiage": {
      "en": "This division payment has already been re-submitted. Money will be pulled at next invoice run.",
      "fr": "Ce paiement de division a déjà été soumis à nouveau. L'argent sera retiré lors de la prochaine exécution de la facture."
    },
    "sysMsg": "Master user is trying to submit a repayment for a division that has already had one submitted.",
    "code": "INVALID_REQUEST"
  },
  "G021": {
    "verbiage": {
      "en": "Your current location does not have access to the Master site.",
      "fr": "Votre emplacement actuel n'a pas accès au site principal."
    },
    "sysMsg": "The master users current ip address is not allowed access.",
    "code": "UNAUTHORIZED"
  },
  "G022": {
    "verbiage": {
      "en": "The provided master user does not have access to the Master site.",
      "fr": "L'utilisateur principal fourni n'a pas accès au site principal."
    },
    "sysMsg": "params[0] does not have access to the Master site.",
    "code": "UNAUTHORIZED"
  },
  "G023": {
    "verbiage": {
      "en": "Bad request, please try again or contact support.",
      "fr": "Mauvaise demande, veuillez réessayer ou contacter l'assistance."
    },
    "sysMsg": "The server request is invalid. params[0]",
    "code": "INVALID_REQUEST"
  },
  "G024": {
    "verbiage": {
      "en": "An params[0] is required to send an params[1] notification.",
      "fr": "Un params[0] est requis pour envoyer une notification params[1]."
    },
    "sysMsg": "An params[0] is required to send an params[1] notification.",
    "code": "INSUFFICIENT_DATA"
  },
  "G025": {
    "verbiage": {
      "en": "The notification type: params[0] is unknown.",
      "fr": "Le type de notification : params[0] est inconnu."
    },
    "sysMsg": "The notification type: params[0] is unknown.",
    "code": "UNKNOWN_TYPE"
  },
  "G026": {
    "verbiage": {
      "en": "Failed to find any banking details.",
      "fr": "Impossible de trouver des coordonnées bancaires."
    },
    "sysMsg": "Failed to find any banking details for member: params[0]",
    "code": "NOT_FOUND"
  },
  "G027": {
    "verbiage": {
      "en": "Failed to upload the optional benefit records. params[0]",
      "fr": ""
    },
    "sysMsg": "Failed to upload the optional benefit records. params[0]",
    "code": "INVALID_REQUEST"
  },
  "G028": {
    "verbiage": {
      "en": "There was an issue generating the NEM Eligibility Report. Please try again",
      "fr": "Un problème est survenu lors de la génération du rapport d’éligibilité NEM. Veuillez réessayer"
    },
    "sysMsg": "There was an issue generating the NEM Eligibility Report\nparams[0]",
    "code": "INVALID_REQUEST"
  },
  "G029": {
    "verbiage": {
      "en": "AccountID is required. Please provide a valid accountID to proceed.",
      "fr": "L'ID de compte est requis. Veuillez fournir un ID de compte valide pour continuer."
    },
    "sysMsg": "The provided accountID is invalid\nparams[0]",
    "code": "INVALID_REQUEST"
  },
  "G030": {
    "verbiage": {
      "en": "Class not found. Please check the name is correct.",
      "fr": "Classe introuvable. Veuillez vérifier que le nom est correct."
    },
    "sysMsg": "Could not find Class\nparams[0]",
    "code": "NOT_FOUND"
  },
  "G031": {
    "verbiage": {
      "en": "Division not found. Please check the name is correct.",
      "fr": "Division introuvable. Veuillez vérifier que le nom est correct."
    },
    "sysMsg": "Could not find Division\nparams[0]",
    "code": "NOT_FOUND"
  },
  "V001": {
    "verbiage": {
      "en": "Something failed while validating the request.",
      "fr": "Quelque chose a échoué lors de la validation de la demande."
    },
    "sysMsg": "Something failed while validating the request: params[0]",
    "code": ""
  },
  "V002": {
    "verbiage": {
      "en": "Your account is disabled, please contact your administrator.",
      "fr": "Votre compte est désactivé, veuillez contacter votre administrateur."
    },
    "sysMsg": "The params[0]: params[1] is trying to login but their account is disabled.",
    "code": "INVALID_USER"
  },
  "V003": {
    "verbiage": {
      "en": "Your account is terminated, please contact your administrator.",
      "fr": "Votre compte est résilié, veuillez contacter votre administrateur."
    },
    "sysMsg": "The params[0]: params[1] is trying to login but their account is terminated.",
    "code": "INVALID_USER"
  },
  "V004": {
    "verbiage": {
      "en": "Login failed, the credentials are incorrect.",
      "fr": "La connexion a échoué, les informations d'identification sont incorrectes."
    },
    "sysMsg": "The provided password is wrong for params[0]: params[1]",
    "code": "CREDENTIALS_FAILED"
  },
  "V005": {
    "verbiage": {
      "en": "Login failed, you have not yet registered.",
      "fr": "La connexion a échoué, vous n'êtes pas encore inscrit."
    },
    "sysMsg": "",
    "code": "INVALID_USER"
  },
  "V006": {
    "verbiage": {
      "en": "The provided email does not have an account. Please correct the email and try again.",
      "fr": "L'e-mail fourni n'a pas de compte. Veuillez corriger l'e-mail et réessayer."
    },
    "sysMsg": "params[0] is trying to submit forgot password with an email: params[1] that has no user record.",
    "code": "NOT_FOUND"
  },
  "V007": {
    "verbiage": {
      "en": "Something failed saving the carrier update record.",
      "fr": "Un problème a échoué lors de l'enregistrement de l'enregistrement de mise à jour de l'opérateur."
    },
    "sysMsg": "The provided carrier update action: params[0] is invalid.",
    "code": "INVALID_REQUEST"
  },
  "V008": {
    "verbiage": {
      "en": "When changing the Waiting Period Waive status the effective date must be the date the member was hired.",
      "fr": "Lors du changement du statut de dispense du délai d'attente, la date d'entrée en vigueur doit être la date à laquelle le membre a été embauché."
    },
    "sysMsg": "The effective date is not the hireDate when changing the waiveEligibilityPeriod status.",
    "code": "INVALID_REQUEST"
  },
  "V009": {
    "verbiage": {
      "en": "Failed to reset password because you are not enrolled. Please check your email for an enrolment invitation or contact your administrator.",
      "fr": "Échec de la réinitialisation du mot de passe car vous n'êtes pas inscrit. Veuillez vérifier votre courrier électronique pour une invitation d'inscription ou contacter votre administrateur."
    },
    "sysMsg": "The params[0]: params[1] is trying to reset password but has no cert.",
    "code": "INVALID_USER"
  },
  "V010": {
    "verbiage": {
      "en": "Failed to find a category for the provider.",
      "fr": "Impossible de trouver une catégorie pour le fournisseur."
    },
    "sysMsg": "The provided providerID has no category",
    "code": "INVALID_REQUEST"
  },
  "V011": {
    "verbiage": {
      "en": "The provided enrol link has expired.",
      "fr": "Le lien d'inscription fourni a expiré."
    },
    "sysMsg": "The member is trying to use their enrollment link but they have already enrolled.",
    "code": "INVALID_REQUEST"
  },
  "V012": {
    "verbiage": {
      "en": "Password validation failed.",
      "fr": "La validation du mot de passe a échoué."
    },
    "sysMsg": "The provided password is wrong for params[0]: params[1]",
    "code": "CREDENTIALS_FAILED"
  },
  "V013": {
    "verbiage": {
      "en": "Please ensure you are using your company email address.",
      "fr": "Veuillez vous assurer que vous utilisez l'adresse e-mail de votre entreprise."
    },
    "sysMsg": "The provided identifiers do not match the user record for email: params[0]. User Identifier: params[1], Account Identifier: params[2]",
    "code": "INVALID_USER"
  },
  "V014": {
    "verbiage": {
      "en": "Please use a unique email for each dependent.",
      "fr": "Veuillez utiliser une adresse e-mail unique pour chaque personne à charge."
    },
    "sysMsg": "User is trying to add multiple dependents with the same email: params[0].",
    "code": "INVALID_REQUEST"
  },
  "V015": {
    "verbiage": {
      "en": "You must provide payment details to enrol.",
      "fr": "Vous devez fournir les informations de paiement pour vous inscrire."
    },
    "sysMsg": "User is trying to enroll under a member payment account without providing payments details.",
    "code": "INVALID_REQUEST"
  },
  "V016": {
    "verbiage": {
      "en": "The provided Key is invalid.",
      "fr": "La clé fournie n'est pas valide."
    },
    "sysMsg": "Maple is trying to make a request but the provided API Key is invalid.",
    "code": "CREDENTIALS_FAILED"
  },
  "V017": {
    "verbiage": {
      "en": "Entity was not found in the system.",
      "fr": "L'entité n'a pas été trouvée dans le système."
    },
    "sysMsg": "The provided params[0] does not exist in the system.",
    "code": "NOT_FOUND"
  },
  "V018": {
    "verbiage": {
      "en": "Failed to pull white label data.",
      "fr": "Échec de l'extraction des données en marque blanche."
    },
    "sysMsg": "No advisor record was found for the provided accountID: params[0]",
    "code": "NOT_FOUND"
  },
  "V019": {
    "verbiage": {
      "en": "Change password failed, the credentials are incorrect.",
      "fr": "Échec de la modification du mot de passe, les informations d'identification sont incorrectes."
    },
    "sysMsg": "params[0] is trying to change password but the provided password is wrong for params[1]: params[2].",
    "code": "CREDENTIALS_FAILED"
  },
  "V020": {
    "verbiage": {
      "en": "The provided Mass Salary Update file is invalid, please confirm all columns exist and are correct.",
      "fr": "Le fichier de mise à jour massive des salaires fourni n'est pas valide. Veuillez confirmer que toutes les colonnes existent et sont correctes."
    },
    "sysMsg": "The provided Mass Salary Update file was invalid because it was missing the column: params[0].",
    "code": "INSUFFICIENT_DATA"
  },
  "V021": {
    "verbiage": {
      "en": "The provided Mass Salary Update file is invalid, Earnings Type must be either Salary or Hourly.",
      "fr": "Le fichier de mise à jour massive des salaires fourni n'est pas valide. Le type de gains doit être Salaire ou Horaire."
    },
    "sysMsg": "The provided Mass Salary Update file was invalid because they are sending an invalid earningsType of: params[0].",
    "code": "INSUFFICIENT_DATA"
  },
  "V022": {
    "verbiage": {
      "en": "The provided email does not exist. Please provide a different email and try again.",
      "fr": "L'e-mail fourni n'existe pas. Veuillez fournir une autre adresse e-mail et réessayer."
    },
    "sysMsg": "params[0] is trying to send forgot password with an email address: params[1] that has no account associated with it.",
    "code": "NOT_FOUND"
  },
  "V023": {
    "verbiage": {
      "en": "You must create at least 1 plan design for each class before continuing.",
      "fr": "Vous devez créer au moins une conception de plan pour chaque classe avant de continuer."
    },
    "sysMsg": "The user is trying to submit the class: params[0] for review but has not set a plan design for class: params[1].",
    "code": "NOT_FOUND"
  },
  "V024": {
    "verbiage": {
      "en": "The provided link is invalid.",
      "fr": "Le lien fourni n'est pas valide."
    },
    "sysMsg": "User is trying to access a params[0] with an invalid link. id: params[1]",
    "code": "INVALID_REQUEST"
  },
  "V025": {
    "verbiage": {
      "en": "The provided account is invalid.",
      "fr": "Le compte fourni n'est pas valide."
    },
    "sysMsg": "Could not find an advisor record for the account: params[0].",
    "code": "NOT_FOUNT"
  },
  "V026": {
    "verbiage": {
      "en": "Adding a member is currently blocked as your account is currently under revisions.",
      "fr": "L'ajout d'un membre est actuellement bloqué car votre compte est actuellement en cours de révision."
    },
    "sysMsg": "",
    "code": ""
  },
  "V027": {
    "verbiage": {
      "en": "Oops, looks like you are missing required data for user: params[0]",
      "fr": "Oups, il semble qu'il vous manque les données requises pour l'utilisateur : params[0]"
    },
    "sysMsg": "User is trying to submit the census without setting all required user data for user: params[0].",
    "code": "INVALID_REQUEST"
  },
  "V028": {
    "verbiage": {
      "en": "The provided class does not exist, please only use existing classes or create a new one.",
      "fr": "La classe fournie n'existe pas, veuillez utiliser uniquement les classes existantes ou en créer une nouvelle."
    },
    "sysMsg": "The class: params[0] could not be found in the system.",
    "code": "NOT_FOUND"
  },
  "V029": {
    "verbiage": {
      "en": "The provided division does not exist, please only use existing divisions or create a new one.",
      "fr": "La division fournie n'existe pas, veuillez utiliser uniquement les divisions existantes ou en créer une nouvelle."
    },
    "sysMsg": "The division: params[0] could not be found in the system.",
    "code": "NOT_FOUND"
  },
  "V030": {
    "verbiage": {
      "en": "The provided coverage type is invalid. Must be one of Solo, Duo, or Family.",
      "fr": "Le type de couverture fourni n’est pas valide. Doit être Solo, Duo ou Famille."
    },
    "sysMsg": "The provided coverage type: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V031": {
    "verbiage": {
      "en": "The provided gender is invalid. Must be one of Female, Male, or Other.",
      "fr": "Le sexe indiqué n'est pas valide. Il doit s'agir d'une femme, d'un homme ou d'un autre."
    },
    "sysMsg": "The provided gender: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V032": {
    "verbiage": {
      "en": "The provided earnings type is invalid. Must be one of Salary or Hourly.",
      "fr": "Le type de revenus fourni n'est pas valide. Doit être un salaire ou un horaire."
    },
    "sysMsg": "The provided earnings type type: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V033": {
    "verbiage": {
      "en": "You must provide an hourly wage if the earnings type is Hourly.",
      "fr": "Vous devez fournir un salaire horaire si le type de gains est Horaire."
    },
    "sysMsg": "The provided hourly wage type: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V034": {
    "verbiage": {
      "en": "You must provide a salary if the earnings type is Salary.",
      "fr": "Vous devez fournir un salaire si le type de gains est Salaire."
    },
    "sysMsg": "The provided salary: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V035": {
    "verbiage": {
      "en": "You must provide hours per week.",
      "fr": "Vous devez fournir des heures par semaine."
    },
    "sysMsg": "The provided hours per week: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V036": {
    "verbiage": {
      "en": "The provided province: params[0] is invalid, please provide the province abbreviation (example: BC, YK, ON).",
      "fr": "La province fournie : params[0] n'est pas valide, veuillez fournir l'abréviation de la province (exemple : BC, YK, ON)."
    },
    "sysMsg": "The provided province: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V037": {
    "verbiage": {
      "en": "The provided date of birth is invalid.",
      "fr": "La date de naissance fournie n'est pas valide."
    },
    "sysMsg": "The provided date of birth: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V038": {
    "verbiage": {
      "en": "The provided hire date is invalid.",
      "fr": "La date de location fournie n'est pas valide."
    },
    "sysMsg": "The provided hire date: params[0] is invalid.",
    "code": "INSUFFICIENT_DATA"
  },
  "V039": {
    "verbiage": {
      "en": "The provided file is invalid, you are missing required columns.",
      "fr": "Le fichier fourni n'est pas valide, il vous manque les colonnes obligatoires."
    },
    "sysMsg": "The provided census file was invalid because it was missing the params[0] column.",
    "code": "INSUFFICIENT_DATA"
  },
  "V040": {
    "verbiage": {
      "en": "Please ensure you are not adding any duplicate email addresses.",
      "fr": "Veuillez vous assurer de ne pas ajouter d'adresses e-mail en double."
    },
    "sysMsg": "User is trying to upload a CSV with duplicate email addresses.",
    "code": "INVALID_REQUEST"
  },
  "V041": {
    "verbiage": {
      "en": "You cannot set this member to Survivor Benefit status as they have no active dependents with an email login.",
      "fr": "Vous ne pouvez pas attribuer à ce membre le statut de prestation de survivant, car il n'a aucune personne à charge active disposant d'une connexion par e-mail."
    },
    "sysMsg": "Master Site user is trying to set the member to Survivor Benefit status but they have no active dependents with an email login.",
    "code": "INVALID_REQUEST"
  },
  "V042": {
    "verbiage": {
      "en": "You must assign a plan design to each class before continuing.",
      "fr": "Vous devez attribuer une conception de plan à chaque classe avant de continuer."
    },
    "sysMsg": "params[0] is trying to assign their plans to their classes but is missing an assignment for class: params[1]",
    "code": "INSUFFICIENT_DATA"
  },
  "V043": {
    "verbiage": {
      "en": "The provided plan type is invalid.",
      "fr": "Le type de plan fourni n'est pas valide."
    },
    "sysMsg": "The provided plan type: params[0] is not a valid option.",
    "code": "INVALID_REQUEST"
  },
  "V044": {
    "verbiage": {
      "en": "The provided claim service is not supported.",
      "fr": "Le service de réclamation fourni n'est pas pris en charge."
    },
    "sysMsg": "User is trying to make a claim for a service we do not support: params[0] under category params[1]",
    "code": "INVALID_CLAIM_TYPE"
  },
  "V045": {
    "verbiage": {
      "en": "The certificate has not been placed in a Survivor Benefit status and is missing a deceased primary cert meta record.",
      "fr": "Le certificat n'a pas été placé dans un statut de prestation de survivant et il manque un méta-enregistrement de certificat principal décédé."
    },
    "sysMsg": "",
    "code": ""
  },
  "V046": {
    "verbiage": {
      "en": "The provided claim type is not supported.",
      "fr": "Le type de revendication fourni n'est pas pris en charge."
    },
    "sysMsg": "User is trying to make a params[0] claim but the provided service: params[1] is not supported.",
    "code": "INVALID_CLAIM_TYPE"
  },
  "V047": {
    "verbiage": {
      "en": "Failed to find the provided dependent in the system.",
      "fr": "Impossible de trouver la personne à charge fournie dans le système."
    },
    "sysMsg": "The dependent: params[0] could not be found in the system under primary: params[1]",
    "code": "DEPENDENT_NOT_FOUND"
  },
  "V048": {
    "verbiage": {
      "en": "Trustee was not found in the system.",
      "fr": "Le syndic n'a pas été trouvé dans le système."
    },
    "sysMsg": "Failed to find Trustee: params[0] in the system.",
    "code": "NOT_FOUND"
  },
  "V049": {
    "verbiage": {
      "en": "The provided benefit: params[0] could not be found.",
      "fr": "L'avantage fourni : params[0] est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "V050": {
    "verbiage": {
      "en": "The provided user type params[0] could not be found.",
      "fr": "Les params de type d'utilisateur fournis[0] sont introuvables."
    },
    "sysMsg": "",
    "code": ""
  },
  "V051": {
    "verbiage": {
      "en": "The provided class: params[0] could not be found.",
      "fr": "La classe fournie : params[0] est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "V052": {
    "verbiage": {
      "en": "The provided carrier: params[0] could not be found.",
      "fr": "Le transporteur fourni : params[0] est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "V053": {
    "verbiage": {
      "en": "Set one of the following: 'month' or 'dateRange'.",
      "fr": "Définissez l'un des éléments suivants : « mois » ou « dateRange »."
    },
    "sysMsg": "",
    "code": ""
  },
  "V054": {
    "verbiage": {
      "en": "The selected date range spans multiple renewal periods.",
      "fr": "La plage de dates sélectionnée s'étend sur plusieurs périodes de renouvellement."
    },
    "sysMsg": "",
    "code": ""
  },
  "V055": {
    "verbiage": {
      "en": "Provided date range was invalid. Please try again.",
      "fr": "La plage de dates fournie n'était pas valide. Veuillez réessayer."
    },
    "sysMsg": "",
    "code": ""
  },
  "V056": {
    "verbiage": {
      "en": "Failed to find the marketplace product.",
      "fr": "Impossible de trouver le produit Marketplace."
    },
    "sysMsg": "Failed to find the marketplace product with productID: params[0] in Dynamo",
    "code": "NOT_FOUND"
  },
  "V057": {
    "verbiage": {
      "en": "There was an issue finding the selected reminder: params[0]",
      "fr": "Un problème est survenu lors de la recherche du rappel sélectionné : params[0]"
    },
    "sysMsg": "The provided reminder: params[0] could not be found in Dynamo",
    "code": "NOT_FOUND"
  },
  "V058": {
    "verbiage": {
      "en": "The provided reminder metaType: params[0] is invalid.",
      "fr": "Le métaType de rappel fourni : params[0] n'est pas valide."
    },
    "sysMsg": "Reminder is failing to be set because the provided metaType: params[0] is invalid.",
    "code": "UNKNOWN_TYPE"
  },
  "V059": {
    "verbiage": {
      "en": "The provided webhook type: params[0] is not supported.",
      "fr": "Le type de webhook fourni : params[0] n’est pas pris en charge."
    },
    "sysMsg": "",
    "code": ""
  },
  "V060": {
    "verbiage": {
      "en": "The provided entity type: params[0] is not supported.",
      "fr": "Le type d'entité fourni : params[0] n'est pas pris en charge."
    },
    "sysMsg": "",
    "code": ""
  },
  "V061": {
    "verbiage": {
      "en": "Failed to send e-signature authorization.",
      "fr": "Échec de l'envoi de l'autorisation de signature électronique."
    },
    "sysMsg": "",
    "code": ""
  },
  "V062": {
    "verbiage": {
      "en": "The provided Lifestyle Spending item is not a valid selection.",
      "fr": "L’élément Dépenses de style de vie fourni n’est pas une sélection valide."
    },
    "sysMsg": "The provided item: params[0] is not a valid LSA option.",
    "code": "INVALID_REQUEST"
  },
  "V063": {
    "verbiage": {
      "en": "The type of change is unknown.",
      "fr": "Le type de changement est inconnu."
    },
    "sysMsg": "The provided type: params[0] is not a valid type for setting an effective date.",
    "code": "INVALID_REQUEST"
  },
  "V064": {
    "verbiage": {
      "en": "The provided Brokerage is already registered.",
      "fr": "Le courtage fourni est déjà enregistré."
    },
    "sysMsg": "User is trying to add a Brokerage: params[0] which already exists.",
    "code": "INVALID_REQUEST"
  },
  "V065": {
    "verbiage": {
      "en": "The provided predetermination could not be found.",
      "fr": "La prédétermination fournie est introuvable."
    },
    "sysMsg": "The provided predetermination: params[0] could not be found in system.",
    "code": ""
  },
  "V066": {
    "verbiage": {
      "en": "The provided transaction could not be found.",
      "fr": "La transaction fournie est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "V067": {
    "verbiage": {
      "en": "The dentist could not be found in the list of registered CDANet dentists.",
      "fr": "Le dentiste n’a pas pu être trouvé dans la liste des dentistes inscrits à CDANet."
    },
    "sysMsg": "The dentist (providerNo: params[0], officeNo: params[1]) could not be found in the list of registered CDANet dentists.",
    "code": "NOT_FOUND"
  },
  "V068": {
    "verbiage": {
      "en": "Failed to backdate member termination because the member has made claims since the termination effective date.",
      "fr": "Échec de l'antidatation de la résiliation du membre, car le membre a déposé des réclamations depuis la date d'entrée en vigueur de la résiliation."
    },
    "sysMsg": "Trying to terminate member but they have claims from after the termination effective date.",
    "code": "INVALID_REQUEST"
  },
  "V069": {
    "verbiage": {
      "en": "The provided Effective Date is invalid.",
      "fr": "La date d’entrée en vigueur fournie n’est pas valide."
    },
    "sysMsg": "The provided params[0] is invalid. params[1]",
    "code": "INVALID_REQUEST"
  },
  "V070": {
    "verbiage": {
      "en": "The provided report type could not be found.",
      "fr": "Le type de rapport fourni est introuvable."
    },
    "sysMsg": "Failed to find the report type: params[0]",
    "code": "NOT_FOUND"
  },
  "V071": {
    "verbiage": {
      "en": "There was an issue finding the selected predetermination. Please try again later.",
      "fr": "Un problème est survenu lors de la recherche de la prédétermination sélectionnée. Veuillez réessayer plus tard."
    },
    "sysMsg": "",
    "code": ""
  },
  "V072": {
    "verbiage": {
      "en": "The provided group: params[0] could not be found.",
      "fr": "Le groupe fourni : params[0] est introuvable."
    },
    "sysMsg": "",
    "code": ""
  },
  "V073": {
    "verbiage": {
      "en": "The account is currently under Revisions, you must wait until the Revisions process has completed to edit this member.",
      "fr": "Le compte est actuellement sous Révisions, vous devez attendre la fin du processus de Révisions pour modifier ce membre."
    },
    "sysMsg": "The account: params[0] is under Revisions and a member who was created before the revisions started is trying to be updated.",
    "code": "UNAUTHORIZED"
  },
  "V074": {
    "verbiage": {
      "en": "You cannot change an Irrevocable Beneficiary.",
      "fr": "Vous ne pouvez pas modifier un Bénéficiaire Irrévocable."
    },
    "sysMsg": "The user: params[0] is trying to params[1] an Irrevocable Beneficiary.",
    "code": "INVALID_REQUEST"
  },
  "V075": {
    "verbiage": {
      "en": "The total shares across your beneficiaries must equal 100%.",
      "fr": "Le total des parts entre vos bénéficiaires doit être égal à 100 %."
    },
    "sysMsg": "The total beneficiary shares do not equal 100%",
    "code": "INVALID_REQUEST"
  },
  "V076": {
    "verbiage": {
      "en": "Please provide a cohab date for the dependent.",
      "fr": "Veuillez fournir une date de cohab pour la personne à charge."
    },
    "sysMsg": "User is trying to create a Common Law dependent without providing a cohab date.",
    "code": "INVALID_REQUEST"
  },
  "V077": {
    "verbiage": {
      "en": "You cannot add new dependents when under Survivor Benefits.",
      "fr": "Vous ne pouvez pas ajouter de nouvelles personnes à charge lorsque vous bénéficiez des prestations de survivant."
    },
    "sysMsg": "User is trying to add a dependent but the member is under Survivor Benefits.",
    "code": "INVALID_REQUEST"
  },
  "V078": {
    "verbiage": {
      "en": "Failed to backdate dependent termination because the dependent has made claims since the termination effective date.",
      "fr": "Échec de l'antidatage de la résiliation d'une personne à charge, car la personne à charge a déposé des réclamations depuis la date d'entrée en vigueur de la résiliation."
    },
    "sysMsg": "Trying to terminate dependent but they have claims from after the termination effective date.",
    "code": "INVALID_REQUEST"
  },
  "V079": {
    "verbiage": {
      "en": "The provided email is already in use.",
      "fr": "L'e-mail fourni est déjà utilisé."
    },
    "sysMsg": "User is trying to add a params[1] with an email: params[0] that is already taken by another params[1].",
    "code": "INVALID_REQUEST"
  },
  "V080": {
    "verbiage": {
      "en": "The account is currently under Revisions, you must wait until the Revisions process has completed to add new members.",
      "fr": "Le compte est actuellement sous Révisions, vous devez attendre la fin du processus de Révisions pour ajouter de nouveaux membres."
    },
    "sysMsg": "Admin: params[0] is trying to add a member but the account is currently under revisions.",
    "code": "UNAUTHORIZED"
  },
  "V081": {
    "verbiage": {
      "en": 'The provided class: "params[0]"  has not been completely setup (missing drug planID). Please contact Simply Benefits support.',
      "fr": "La classe fournie n’a pas été complètement configurée (ID du régime d’assurance-médicaments manquant). Veuillez contacter l’assistance Simply Benefits."
    },
    "sysMsg": 'The provided class: "params[0]" is missing a Telus Plan ID (drug plan ID).',
    "code": "INSUFFICIENT_DATA"
  },
  "V082": {
    "verbiage": {
      "en": "Oops, looks like you are missing pricing data for class: params[2].",
      "fr": "Oups, il semblerait qu'il vous manque des données de tarification."
    },
    "sysMsg": "Master Site user is trying to submit the pricing without first setting params[0] pricing for plan design: params[1] under class: params[2]",
    "code": "NOT_FOUND"
  },
  "V083": {
    "verbiage": {
      "en": "You do not have access to this resource.",
      "fr": "Vous n'avez pas accès à cette ressource."
    },
    "sysMsg": "The provided params[0] does not have access to the params[1].",
    "code": "UNAUTHORIZED"
  },
  "V084": {
    "verbiage": {
      "en": "Please ensure you are using the Parent Class names. For example, use \"A\" instead of \"Silver Health & Silver Dental\"",
      "fr": "Veuillez vous assurer que vous utilisez les noms de classe parent. Par exemple, utilisez « A » au lieu de « Silver Health"
    },
    "sysMsg": "Failed to find mod flex class during census upload because they are not using the parent class names.",
    "code": "INVALID_REQUEST"
  },
  "V085": {
    "verbiage": {
      "en": "The account termination can not be completed at this time. This account currently has pending claims. Please adjudicate the claims, and then try the termination again.",
      "fr": "La résiliation du compte ne peut pas être finalisée pour le moment. Ce compte a actuellement des réclamations en attente. Veuillez examiner les réclamations, puis réessayer la résiliation."
    },
    "sysMsg": "Accounts with active claims cannot be terminated. Adjudicate these claims: [params[0]] for accountID params[1] before termination.",
    "code": "INVALID_REQUEST"
  },
  "V086": {
    "verbiage": {
      "en": "The account is not a modular flex account.",
      "fr": "Le compte n'est pas un compte flexible modulaire."
    },
    "sysMsg": "The account is not a modular flex account, however, we are trying to save the modular flex blueprints.",
    "code": "INVALID_REQUEST"
  },
  "V087": {
    "verbiage": {
      "en": "Failed to find an active plan design for the users class.",
      "fr": "Impossible de trouver une conception de plan active pour la classe d'utilisateurs."
    },
    "sysMsg": "Failed to find an active plan design for the users class: params[0]",
    "code": "NOT_FOUND"
  },
  "V088": {
    "verbiage": {
      "en": "Code: params[0] - This procedure is a duplicate from params[1].",
      "fr": "Code : params[0] - Cette procédure est un double de params[1]."
    },
    "sysMsg": "The procedure is a duplicate.",
    "code": "INVALID_REQUEST"
  },
  "V089": {
    "verbiage": {
      "en": "Code: params[0] - The procedure code: params[1] is unknown in system.",
      "fr": "Code : params[0] - Le code de procédure : params[1] est inconnu dans le système."
    },
    "sysMsg": "The dental procedure code is unknown in system.",
    "code": "INVALID_REQUEST"
  },
  "V090": {
    "verbiage": {
      "en": "The member has reached the termination age params[0]",
      "fr": "Le membre a atteint les params d'âge de résiliation[0]"
    },
    "sysMsg": "The member has reached the termination age.",
    "code": "INVALID_REQUEST"
  },
  "V091": {
    "verbiage": {
      "en": "Procedure Code: params[0] is not covered under the plan.",
      "fr": "Code de procédure : params[0] n’est pas couvert par le plan."
    },
    "sysMsg": "Procedure code is not covered under the plan.",
    "code": "INVALID_REQUEST"
  },
  "V092": {
    "verbiage": {
      "en": "Procedure Code: params[0] coverage has been terminated.",
      "fr": "Code de procédure : la couverture params[0] a pris fin."
    },
    "sysMsg": "Coverage for the procedure code has been terminated.",
    "code": "INVALID_REQUEST"
  },
  "V093": {
    "verbiage": {
      "en": "Code: params[0] - Surfaces: params[1] already had work within the period.",
      "fr": "Code : params[0] - Surfaces : params[1] a déjà eu du travail dans la période."
    },
    "sysMsg": "Tooth surface already had work within the period.",
    "code": "INVALID_REQUEST"
  },
  "V094": {
    "verbiage": {
      "en": "Code: params[0] - Member has reached the maximum for the service type.",
      "fr": "Code : params[0] - Le membre a atteint le maximum pour le type de service."
    },
    "sysMsg": "Member has reached the maximum for the service type",
    "code": "INVALID_REQUEST"
  },
  "V095": {
    "verbiage": {
      "en": "Code: params[0] - Claim exceeds dental plan's scaling/root planing.",
      "fr": "Code : params[0] - La réclamation dépasse le détartrage/surfaçage radiculaire du régime de soins dentaires."
    },
    "sysMsg": "Dental claim exceeds dental plan scaling/root planing.",
    "code": "INVALID_REQUEST"
  },
  "V096": {
    "verbiage": {
      "en": "Procedure Code: params[0] exceeds the Reasonable and Customary.",
      "fr": "Code de procédure : params[0] dépasse les valeurs raisonnable et habituelle."
    },
    "sysMsg": "Procedure Code: params[0] exceeds the Reasonable and Customary.",
    "code": "INVALID_REQUEST"
  },
  "V097": {
    "verbiage": {
      "en": "Treatment has reached the maximum covered under the plan.",
      "fr": "Le traitement a atteint le maximum couvert par le régime."
    },
    "sysMsg": "Treatment has reached the maximum covered under the plan.",
    "code": "INVALID_REQUEST"
  },
  "V098": {
    "verbiage": {
      "en": "Unable to locate the units of scaling for code: params[0] in the year: params[1].",
      "fr": "Impossible de localiser les unités de mise à l'échelle pour le code : params[0] dans l'année : params[1]."
    },
    "sysMsg": "Failure while validating the scaling usage.",
    "code": "INVALID_REQUEST"
  },
  "V099": {
    "verbiage": {
      "en": "The substitution code for the remaining params[0] units of scaling is not found.",
      "fr": "Le code de substitution pour les unités de mise à l'échelle params[0] restantes est introuvable."
    },
    "sysMsg": "Failure while validating the scaling usage.",
    "code": "INVALID_REQUEST"
  },
  "V100": {
    "verbiage": {
      "en": "Unknown procedure code.",
      "fr": "Code de procédure inconnu."
    },
    "sysMsg": "The procedure code is unknown.",
    "code": "INVALID_REQUEST"
  },
  "V101": {
    "verbiage": {
      "en": "The provided contractName: params[0] is unknown.",
      "fr": "Le contractName fourni : params[0] est inconnu."
    },
    "sysMsg": "The provided contractName: params[0] is unknown",
    "code": "INVALID_REQUEST"
  },
  "V102": {
    "verbiage": {
      "en": "You cannot remove the Plan Sponsor",
      "fr": "Vous ne pouvez pas supprimer le promoteur du régime"
    },
    "sysMsg": "An admin: params[0] is trying to remove the plan sponsor from the account.",
    "code": "INVALID_REQUEST"
  },
  "V103": {
    "verbiage": {
      "en": "Code: params[0] - Service date is before the eligibility date.",
      "fr": "Code : params[0] - La date de service est antérieure à la date d'éligibilité."
    },
    "sysMsg": "Service date for the dental claim is before the eligibility date.",
    "code": "INVALID_REQUEST"
  },
  "V104": {
    "verbiage": {
      "en": "Code: params[0] - Service date is before the dependent eligibility date.",
      "fr": "Code : params[0] - La date de service est antérieure à la date d'éligibilité des personnes à charge."
    },
    "sysMsg": "Service date for the dental claim is before the dependent eligibility date.",
    "code": "INVALID_REQUEST"
  },
  "V105": {
    "verbiage": {
      "en": "Code: params[0] - Service date is more than a year old.",
      "fr": "Code : params[0] - La date de service date de plus d'un an."
    },
    "sysMsg": "Service date for the dental claim is more than 1 year old.",
    "code": "INVALID_REQUEST"
  },
  "V106": {
    "verbiage": {
      "en": "Code: params[0] - No Service Date was provided.",
      "fr": "Code : params[0] - Aucune date de service n'a été fournie."
    },
    "sysMsg": "No Service Date was provided for the dental claim.",
    "code": "INVALID_REQUEST"
  },
  "V107": {
    "verbiage": {
      "en": "Failure while validating the scaling usage.",
      "fr": "Échec lors de la validation de l'utilisation de la mise à l'échelle."
    },
    "sysMsg": "Failure while validating the scaling usage.",
    "code": "INVALID_REQUEST"
  },
  "V108": {
    "verbiage": {
      "en": "Failed to send push notification. They have not allowed Simply Benefits to send push notifications to their device.",
      "fr": "Échec de l'envoi de la notification push. Ils n'ont pas autorisé Simply Benefits à envoyer des notifications push sur leur appareil."
    },
    "sysMsg": "Failed to send push notification to params[0]. They have not allowed Simply Benefits to send push notifications to their device",
    "code": "UNAUTHORIZED"
  },
  "V109": {
    "verbiage": {
      "en": "Failed to send email notification. Please check the email address is correct.",
      "fr": "Échec de l'envoi de la notification par e-mail. Veuillez vérifier que l'adresse e-mail est correcte."
    },
    "sysMsg": "Failed to send email notification to params[0].",
    "code": "INVALID_REQUEST"
  },
  "V110": {
    "verbiage": {
      "en": "The selected product does not have anymore policy numbers available.",
      "fr": "Le produit sélectionné n'a plus de numéro de police disponible"
    },
    "sysMsg": "The selected Marketplace product: params[0] does not have anymore block policy numbers available.",
    "code": "INVALID_REQUEST"
  },
  "V111": {
    "verbiage": {
      "en": "The provided email address is not registered.",
      "fr": "L'adresse courriel fournie n'est pas enregistrée."
    },
    "sysMsg": "The provided params[0] does not exist in the system.",
    "code": "NOT_FOUND"
  },
  "V112": {
    "verbiage": {
      "en": "Please ensure you have set a params[1] for all products and classes.",
      "fr": "Veuillez vous assurer d'avoir défini un paramètre[1] pour tous les produits et classes."
    },
    "sysMsg": "params[0] is trying to save speciality rates but has not set a params[1].",
    "code": "INVALID_REQUEST"
  },
  "V113": {
    "verbiage": {
      "en": "The Company name params[0] is already in use. Please choose a different name.",
      "fr": "Le nom de la société params[0] est déjà utilisé. Veuillez choisir un autre nom."
    },
    "sysMsg": "Company name params[0] has already been taken",
    "code": "INVALID_REQUEST"
  },
  "V114": {
    "verbiage": {
      "en": "The request could not be processed because some required parameters are missing.",
      "fr": "La demande n'a pas pu être traitée car certains paramètres requis sont manquants."
    },
    "sysMsg": "Required params params[0] are missing from params[1].",
    "code": "INVALID_REQUEST"
  },
  "V115": {
    "verbiage": {
      "en": "When changing the Waiting Period Waive status with a reinstate date in the system the effective date must be the date the member was hired or reinstated.",
      "fr": "Lorsque vous modifiez le statut de dispense du délai d'attente avec une date de réintégration dans le système, la date d'entrée en vigueur doit être la date à laquelle le membre a été embauché ou réintégré."
    },
    "sysMsg": "The effective date is not the hireDate or reinstateDate when changing the waiveEligibilityPeriod status with a current reinstate date in the system.",
    "code": "INVALID_REQUEST"
  }
};